import { Helmet } from "react-helmet-async";

const SITE_URL = "https://geniebot.pro";

interface SEOProps {
  title: string;
  description: string;
  path?: string;
  ogType?: "website" | "article";
  image?: string;
  /** Optional JSON-LD object (or array of objects) to inject for this route. */
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  /** Keep this route out of search results (error pages, token-only flows). */
  noindex?: boolean;
}

/**
 * Per-route SEO head tags. Sets title, meta description, canonical, and
 * og:* tags scoped to the current page. Overrides the static defaults
 * shipped in index.html for JS-executing crawlers.
 */
export const SEO = ({
  title,
  description,
  path = "/",
  ogType = "website",
  image,
  jsonLd,
  noindex = false,
}: SEOProps) => {
  const url = `${SITE_URL}${path}`;
  const ogImage = image ?? "https://geniebot.pro/icon-192.png";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, follow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
